import React from "react";

export const Types03: React.FC = () => {
  return (
    <div className="types03-section">
      <div className="moreinfo-container">
        <h2 className="moreinfo-title moreinfo-title-blue moreinfo-title-left">Tipos de endo</h2>
        
        <div className="moreinfo-content">
          <div className="moreinfo-left">
            <p className="moreinfo-text">
              Esto marca la importancia de que las personas con endometriosis sean tratadas por verdaderos especialistas,
              capaces de reconocer la enfermedad en todas sus presentaciones.
            </p>
            
            <p className="moreinfo-text types03-highlight">
              <span className="moreinfo-highlight-blue">Los ginecólogos generales no tienen la formación necesaria para tratar
                la patología y deberían derivar a sus pacientes a centros especializados siempre que sea posible.</span>
            </p>
            
            <p className="moreinfo-text">
              Es simple: si te tienen que operar del corazón o de la rodilla, te van a derivar a un cirujano cardíaco o a un
              cirujano traumatológico. En el caso de la endometriosis tendríamos que poder aspirar a lo mismo y que nos atiendan
              verdaderos <span className="moreinfo-highlight-blue">expertos</span> en el tema.
            </p>
          </div>
          
          <div className="moreinfo-right">
            <p className="moreinfo-text">
              <span className="moreinfo-highlight-blue">TIP:</span> Si te van a realizar una cirugía por laparoscopía, en las citas
              previas de preparación, pídele a tu médico que saque fotos o videos cortos de la misma para dártelos. De esta forma,
              si más adelante en el tiempo tuvieras que hacer una consulta o ver a un especialista nuevo, ya tienes información
              súper importante para mostrarle. Ya sabes lo que dicen: ¡una imagen vale más que mil palabras!
            </p>
            
            <p className="moreinfo-text">
              En caso de que te pongan algún tipo de obstáculo, recuerda que así como te dan las imágenes de una ecografía o de
              una resonancia magnética, esto también es tu derecho y forma parte de tu historial personal. Aunque los médicos estén
              menos acostumbrados a que se las soliciten, estás en todo tu derecho de tenerlas.
            </p>
          </div>
        </div>
        
        <p className="moreinfo-footer">
          <strong>Fuentes:</strong> <a href="https://www.instagram.com/lulaendocomunidad/" target="_blank" rel="noopener noreferrer">Post de @lulaendocomunidad traducido de la Dr. Rebecca Mallick</a><br />
          <a href="http://www.insixteenyears.com" target="_blank" rel="noopener noreferrer">www.insixteenyears.com</a>
        </p>
      </div>
    </div>
  );
};